export default "__VITE_ASSET__DDBQ$6Bg__"